import { shrpaApi } from "./axios";

// Types
import { CollabInput, CollabSettingsForClient, DestinationContactUpdatePayload, OverlappingVisitsScheduleUpdatePayload, OverlappingVisitsScheduleUpdateResponse, VisitsMarkedReadyToPostResponse } from "@contracts/collab";

export default {
  async loadHighlights(communityId: string, collabInputId: string, creatorId: string): Promise<string[]> {
    if (!creatorId) return [];

    const uri = `/collabs/${communityId}/inputs/${collabInputId}/creator/${creatorId}/highlights`;

    const response = await shrpaApi.get<string[]>(uri);
    return response.data;
  },
  async loadCollabSettings(): Promise<CollabSettingsForClient> {
    const { data } = await shrpaApi.get<CollabSettingsForClient>("/collabs/settings");
    return data;
  },

  async loadCustomerCollabs(customerId: string): Promise<Array<CollabInput>> {
    const uri = `/collabs/${customerId}`;
    const { data } = await shrpaApi.get<Array<CollabInput>>(uri);

    return data;
  },

  async loadAnonymousGuidanceSummary(communityId: string, collabInputId: string): Promise<CollabInput> {
    const uri = `/collabs/${communityId}/inputs/${collabInputId}/guidance-summary`;
    const { data } = await shrpaApi.get<Array<CollabInput>>(uri);

    return data;
  },

  async updateDestinationContact(customerId: string, collabInputId: string, payload: DestinationContactUpdatePayload): Promise<CollabInput> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/destination-contact`;
    const { data } = await shrpaApi.put<CollabInput>(uri, payload);
    return data;
  },

  async loadVisitsMarkedReadyToPost(customerId: string): Promise<VisitsMarkedReadyToPostResponse> {
    const { data } = await shrpaApi.get<VisitsMarkedReadyToPostResponse>(`/collabs/${customerId}/visits-marked-ready-to-post`);
    return data;
  },

  async updateOverlappingVisitsSchedule(customerId: string, payload: OverlappingVisitsScheduleUpdatePayload): Promise<OverlappingVisitsScheduleUpdateResponse> {
    const { data } = await shrpaApi.put<OverlappingVisitsScheduleUpdateResponse>(`/collabs/${customerId}/visits-marked-ready-to-post/schedule`, payload);
    return data;
  },
};
